import { SymbolTilesStreamManager } from 'widgets/symbolTile/stream/SymbolTilesStreamManager';
import { WidgetCustomManagedStreamConfig } from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';

export const symbolTileStreamConfig: WidgetCustomManagedStreamConfig = {
    channelDestination: 'startSymbolTilesStream',
    managerFactory: (options) => new SymbolTilesStreamManager(options),
};
